// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class JanssenGECheckResponseModel {
    static getAttributeTypeMap() {
        return JanssenGECheckResponseModel.attributeTypeMap;
    }
}
JanssenGECheckResponseModel.discriminator = undefined;
JanssenGECheckResponseModel.attributeTypeMap = [
    {
        "name": "patientAccountFound",
        "baseName": "patientAccountFound",
        "type": "boolean"
    },
    {
        "name": "responseType",
        "baseName": "responseType",
        "type": "string"
    },
    {
        "name": "isEligible",
        "baseName": "isEligible",
        "type": "boolean"
    },
    {
        "name": "info",
        "baseName": "info",
        "type": "string"
    }
];
//# sourceMappingURL=janssenGECheckResponseModel.js.map